import { isArray } from 'lodash'
import { USD } from './NumberHelper'

const toTitleCase = str => {
  str = str.replace('_', ' ').split(' ')
  for (let i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1)
  }
  return str.join(' ')
}

function getLabel(key) {
  if (key) {
    switch (key) {
      case 'metals':
        return 'Metal(s) / Material(s)'
      case 'jewelry_metal':
      case 'metal_name':
        return 'Metal'
      case 'price_filter':
        return 'Price'
      case 'case_length_value':
        return 'Case Length'
      case 'case_size_mm':
        return 'Case Size'
      case 'case_size_value':
        return 'Case Size'
      case 'case_material':
        return 'Case Material'
      case 'dial_color_attribute':
        return 'Dial Color'
      case 'age_attribute':
        return 'Age'
      // case 'gender_attribute':
      //   return 'Gender [DEL]!!!'
      case 'band_metal':
        return 'Band Material'
      case 'head_metal':
        return 'Case Metal'
      case 'gender_mfu':
        return 'Gender'
      case 'lug_to_lug_length':
        return 'Lug to lug length'
      case 'case_size':
        return 'Case Size'
      case 'band_width':
        return 'Lug Width'
      case 'band_length':
        return 'Buckle Width'
      case 'extras':
        return 'Delivery Contents'
      case 'size':
        return 'Size'
      default:
        return toTitleCase(key)
    }
  }
  return key
}

function getTagValue(val, ifnull = '') {
  if (!val) return ifnull
  if (isArray(val)) return val.map(v => getTagValue(v, ifnull)).join(', ')
  const facetParts = val.split(':')
  if (facetParts.length !== 2) return ifnull
  return getValue(facetParts[0], facetParts[1])
}

function getValue(key, value) {
  switch (key) {
    case 'qty':
      return value > 0 ? ' In stock' : 'Sold out'
    case 'item_type':
      return value === 'Sterling Silver' ? 'Tableware' : value
    case 'case_size_mm':
    case 'case_size_value':
    case 'case_thickness':
    case 'band_length':
    case 'band_width':
    case 'case_length':
    case 'case_length_value':
      return value + 'mm'
    case 'band_size':
      return value + ' inches'
    case 'lug_to_lug_length':
      return Math.round(10 * parseFloat(value)) / 10 + 'mm '
    case 'size':
      if (!value) return ''
      // replace everything inside brackets, i.e. "Large (>39mm)" leaves "Large"
      return (value || '').toString().replace(/\(.*\)/, '')
    case 'metal_name':
      return typeof value === 'string' ? value : (value?.metals || []).join('\n ')
    // return value.join('\n').replace(' and ', '\n')
    case 'stones':
      return (value?.values || [])
        .map(
          stone =>
            (stone.total_weight ? `${stone.total_weight} ` : '') +
            `${[
              // stone.qty > 0 ? `${stone.qty} x` : null,
              stone.color ? `${stone.color}` : null,
              stone.clarity ? `${stone.clarity}` : null,
              stone.type,
              stone.weight > 0 && stone.qty > 1
                ? `(${stone.qty} x ${stone.weight} ${stone.weight_unit})`
                : null,
            ]
              .filter(s => s)
              .join(' ')}`
        )
        .join('\n')
        .replace(' and ', '\n')
    case 'metals':
    case 'features':
      //return value['values'].join(', ')
      return (value?.values || []).join('\n').replace(' and ', '\n')
    case 'min_price':
      return `> ${USD(value)}`
    case 'max_price':
      return `< ${USD(value)}`
    case 'original_box':
    case 'original_papers':
    case 'booklets':
      return value && Number.parseInt(value) > 0 ? toTitleCase(key) : 'No ' + toTitleCase(key)
    case 'extras':
      return toTitleCase(value)
    default:
      return value
  }
}

const slugify = str => {
  str = str.replace(/(^\s+)|(\s+$)/g, '')
  str = str.toLowerCase()
  //noinspection SpellCheckingInspection
  let from =
    'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;'
  //noinspection SpellCheckingInspection
  let to =
    'AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------'
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
  }
  str = str
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
  return str
}

const uniformUrl = (url, origin = '/') => {
  if (!url) return url
  if (url.slice(-1) !== '/') url += '/'
  if (url.indexOf(origin) === 0) return url
  return origin + url
}

const toLowerSnakeCase = input =>
  input
    .replace(/([a-z])([A-Z])/g, '$1_$2') // Add underscore between camelCase transitions
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/-+/g, '_') // Replace hyphens with underscores
    .toLowerCase() // Convert to lowercase

const repairTitle = title => {
  if (!title) return 'Watch Repair & Service'
  if (title.toLowerCase().includes('repair')) return title + ' & Service'
  return title + ' Repair & Service'
}

export { getLabel, slugify, getValue, uniformUrl, getTagValue, toLowerSnakeCase, repairTitle }
